import {
  LitElement,
  html
} from 'lit';
import FooterStyle from './style.js';
import GridStyle from '../Common/GridStyle.js';

export class LdsFooter extends LitElement {
  static get styles() {
    return [FooterStyle, GridStyle];
  }

  render() { // eslint-disable-line
    return html`
      <footer
        id="lds-footer"
        class="lds-footer"
      >
        <div class="wrapper">
          <div>
            <slot name=default></slot>
          </div>
          <div class="row">
            <div class="col-12 col-md-9 lds-footer-menu-links">
              <slot name="menu-links"></slot>
            </div>
            <div class="col-12 col-md-3 lds-footer-support">
              <slot name="support"></slot>
            </div>
          </div>
          <div class="row">
            <div class="lds-footer-meta col-12">
              <slot name="meta"></slot>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-auto order-md-2 ml-auto">
              <div class="lds-footer-social-icons">
                <slot name="social"></slot>
              </div>
              <div class="lds-footer-global-links">
                <slot name="global-links"></slot>
              </div>
            </div>
            <div class="col-12 col-md-auto order-md-1 lds-footer-logo">
              <slot name="logo"></slot>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-footer')) window.customElements.define('lds-footer', LdsFooter);
}

export default { LdsFooter, defineComponent };
